// extracted by mini-css-extract-plugin
export default {"caption":"PhuHuynhChildList_caption__ZscLy","list_horizontal":"PhuHuynhChildList_list_horizontal__uTnYp","list_horizontal_item":"PhuHuynhChildList_list_horizontal_item__4WRm6"};